import React, { useState, useEffect } from 'react';
import { isAuthenticated } from "../../store/action/auth";
import {getCatalog, createForm, updateCatalog, createCatalog} from "../../store/action/catalog";
import { getAddresses } from "../../store/action/address";
import { Redirect } from 'react-router-dom';
import _ from "lodash";
import LoadingBar from "react-top-loading-bar";
import numeral from "numeral";
import { updateCatalogHeaderImage } from "../../store/action/catalog";
import { ChromePicker } from 'react-color'
import {relativeTimeRounding} from "moment";
import PaymentWarning from "../../components/warnings/Payment";
import {Button} from "../../components/buttons";
import Freshchat from "../../components/atoms/FreshChat";

const Form = () => {
    const { user, token } = isAuthenticated();
    const [ addresses, setAddresses ] = useState([]);
    const [ values, setValues] = useState({
        progress:0,
        loading:true,
        error:false
    });
    const [ loadingCatalog, setLoadingCatalog ] = useState(false);
    const [ loadingHeaderImage, setLoadingHeaderImage ] = useState(false);
    const [ color, setColor ] = useState({
        color:'',
        display:false,
        type:''
    });
    const [ catalog, setCatalog ] = useState({
        addressName:'',
        addressPhone:'',
        addressDetails:'',
        addressCoordinate:{},
        addressNote:'',
        additionalItemName:'',
        additionalItemPrice:'',
        additionalItemCourierBased:'',
        products: [],
        productId:'',
        productName: '',
        productPrice: '',
        productDetails: '',
        productImage: '',
        productLength:0,
        productHeight:0,
        productWidth:0,
        productWeight:0,
        productCategory:'',
        category:'',
        categories:[],
        catalogId: '',
        fieldEmail: false,
        fieldName: false,
        fieldPhone: false,
        fieldAdditionalFee:false,
        userId: '',
        organizationId: '',
        title: '',
        description: '',
        subtitle: '',
        status: '',
        link:'',
        style: {
            headerImage: '',
            buttonBorderColor: '#000000',
            buttonColor: '#000000',
            buttonFontColor: '#ffffff',
            backgroundColor: '#000000',
            subtitleFontFamily: 'arial',
            titleFontFamily: 'arial'
        }
    });

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        setValues({...values, loading:true});
        try {
            const resCat = await getCatalog(token);
            const resAd = await getAddresses();

            if (resCat.success && resAd.success) {
                if (_.isEmpty(resCat.catalog)) {
                    setValues({
                        ...values,
                        loading:false
                    })
                    return
                }
                let resAddresses = resAd.addresses.reduce((result, i) => {
                    result.push({
                        addressName:i.name,
                        addressPIC:i.PIC,
                        addressDetails: i.details,
                        addressNote:i.note,
                        coordinate:i.coordinate,
                        postalCode: i.postalCode,
                        provinceId: i.provinceId,
                        provinceName: i.provinceName,
                        cityId: i.cityId,
                        cityName: i.cityName,
                        districtId: i.districtId,
                        districtName: i.districtName,
                        subdistrictId: i.subdistrictId,
                        subdistrictName: i.subdistrictName
                    });
                    return result
                }, []);

                if (resAd.addresses.length === 0) {
                    setAddresses([]);
                } else {
                    setAddresses ( resAddresses );
                }

                if (_.isEmpty(resCat.catalog)){
                    setCatalog({
                        ...catalog,
                        addressName:resAddresses[0].addressName,
                        addressPhone:resAddresses[0].addressPIC,
                        addressDetails:resAddresses[0].addressDetails,
                        addressCoordinate:resAddresses[0].coordinate,
                        addressNote:resAddresses[0].addressNote
                    });
                } else {
                    let existingStyle = catalog.style;
                    let newStyle = resCat.catalog.style;
                    let style = {
                        ...existingStyle,
                        ...newStyle
                    };

                    setCatalog({
                        ...catalog,
                        addressName:resCat.catalog.address.name,
                        addressPhone:resCat.catalog.address.phone,
                        addressDetails:resCat.catalog.address.location,
                        addressCoordinate:resCat.catalog.address.coordinate,
                        addressNote:resCat.catalog.address.note,
                        additionalItemName: resCat.catalog.additions.itemName,
                        additionalItemPrice: resCat.catalog.additions.itemPrice,
                        additionalItemCourierBased: resCat.catalog.additions.itemBasedOnCourierType,
                        catalogId: resCat.catalog._id,
                        categories: resCat.catalog.categories,
                        createdAt: resCat.catalog.createdAt,
                        description: resCat.catalog.description,
                        fieldEmail: resCat.catalog.fields.email,
                        fieldName: resCat.catalog.fields.name,
                        fieldPhone: resCat.catalog.fields.phone,
                        fieldAdditionalItem : resCat.catalog.fields.additionalItem,
                        link: resCat.catalog.link,
                        organizationId: resCat.catalog.organizationId,
                        products: resCat.catalog.products,
                        status: resCat.catalog.status,
                        style: style,
                        subtitle: resCat.catalog.subtitle,
                        title: resCat.catalog.title,
                        updatedAt: resCat.catalog.updatedAt,
                        userId: resCat.catalog.userId
                    });
                }
            }
            setValues({
                ...values,
                loading:false
            })
        } catch (e) {
            console.log (e);
            alert(`Maaf. Gagal ambil data katalog.`)
            setValues({
                ...values,
                loading:false
            })
        }
    };

    const handleDisplayColor = (type) => {
        setColor({
            display:true,
            type
        })
    };

    const handleCatalogChange = name => e => {
        const value = e.target.value;
        setCatalog({ ...catalog, error:false, success:false, [name]: value });
    };

    const handleFieldChange = name => e => {
        const value = e.target.value;
        if (value === 'false' || value === false) {
            setCatalog({ ...catalog, error:false, success:false, [name]: false });
        } else {
            setCatalog ( {...catalog, error: false, success: false, [name]: true} );
        }
    };

    const handleStylingChange = name => e => {
        let styleCopy = catalog.style;
        if (name === 'backgroundColor' ||
            name === 'buttonColor' ||
            name === 'buttonBorderColor' ||
            name === 'buttonFontColor'
        ) {
            styleCopy[name] = e.hex
        } else {
            styleCopy[name] = e.target.value;
        }

        setCatalog({
            ...catalog,
            error:false,
            success:false,
            style:styleCopy
        });
        setColor({
            ...color,
            color:e.hex
        });
    };


    const onUpdateCatalog = async () => {
        setLoadingCatalog(true);
        let nc = {
            addressName: catalog.addressName,
            addressDetails: catalog.addressDetails,
            addressPhone: catalog.addressPhone,
            addressNote: catalog.addressNote,
            addressCoordinate:  catalog.addressCoordinate,
            additionalItemName: catalog.additionalItemName,
            additionalItemPrice: catalog.additionalItemPrice,
            additionalItemBasedOnCourierType:catalog.additionalItemCourierBased,
            catalogTitle: catalog.title,
            catalogSubtitle: catalog.subtitle,
            catalogDescription: catalog.description,
            catalogStyle: catalog.style,
            fieldEmail:catalog.fieldEmail,
            fieldAdditionalItem:catalog.fieldAdditionalItem,
            status: 'active'
        };

        let resCat = await updateCatalog(token, catalog.catalogId, nc);

        if (resCat.success) {
            alert("Katalog berhasil dibuat.");
            window.location.reload()
        } else {
            alert("Katalog gagal dibuat. Mohon ulangi kembali.")
        }
    };

    const onHeaderSelect = async (e,catalogId) => {
        setLoadingHeaderImage(true);
        const data = e.target.files[0];
        const res = await updateCatalogHeaderImage(token, catalogId, data);
        if(res.success) {
            alert("Header telah diupdate");
            let copyStyle = catalog.style;
            copyStyle['headerImage'] = res.image;
            setCatalog({
                ...catalog,
                style: copyStyle
            })
        } else {
            alert("Header gagal diupadte. Coba ulangi lagi yuk!")
        }
        setLoadingHeaderImage(false);
    };
    const onSubmitCatalog = async () => {
        if (!catalog.title) {
            return alert("Anda belum mengaktifkan katalog. Aktifin dulu ya katalognya :)")
        }
        if (catalog.title === '-') {
            return alert("Anda belum memberi nama katalog Anda. Beri nama dulu ya :)")
        }
        if (!catalog.addressName) {
            return alert("Anda belum memasukkan alamat di katalog Anda. Masukkan dulu ya :)")
        }

        const resCat = await createForm(token, catalog.catalogId);

        if (resCat.success) {
            if (catalog.link === "-") {
                alert("Form berhasil dibuat.");
            } else {
                alert("Form berhasil diupdate.");
            }
            window.location.href = "/form";
        } else {
            alert("Form gagal dibuat. Mohon ulangi kembali.")
        }
    };

    const productView = () => {
        let products = catalog.products.slice(0,3);
        if (products.length === 0) {
            return (
                <div className="p-4">
                    <p>Anda belum menambahkan produk di katalog. Mohon ditambah untuk melihat tampilan produk di form</p>
                </div>
            )
        }
        let items = products.map((i,idx) => (
            <div key={idx} className="row form-product py-1 px-3">
                <div className="col-3">
                    {
                        i.image ?
                            <img src={i.image} style={{height:100, width:100}} className="rounded"/> :
                            <i>no image</i>
                    }
                </div>
                <div className="col-6 text-left pl-4">
                    <b>{i.name}</b>
                    <p className="mb-0">{i.details}</p>
                    <b>Rp. {numeral(i.price).format("0,0")}</b>
                </div>
                <div className="col-3">
                    <div
                        className="btn-group btn-group-sm"
                        style={{marginTop:-24}}
                        role="group">
                        <button
                            className="btn btn-primary btn-sm"
                            style={{
                                backgroundColor:catalog.style.buttonColor,
                                borderColor:catalog.style.buttonBorderColor,
                                color:catalog.style.buttonFontColor
                            }}
                        >
                            -
                        </button>
                        <button
                            className="btn btn-primary btn-sm"
                            style={{
                                backgroundColor:catalog.style.buttonColor,
                                borderColor:catalog.style.buttonBorderColor,
                                color:catalog.style.buttonFontColor
                            }}
                        >
                            +
                        </button>
                    </div>
                </div>
            </div>
        ));

        return (
            <div className="container pl-4">
                {items}
            </div>
        )
    };

    if (values.loading) {
        return (
            <div className="bg-white rounded shadow">
                <LoadingBar progress={values.progress} color='#059fe6' height={5}/>
                <div className="p-4">
                    <h5>Tampilan Form Order Katalog</h5>
                </div>
                <div className="p-4">
                    Loading...
                </div>
            </div>
        )
    }

    if (catalog.link === "-" || !catalog.link) {
        return (
            <div className="text-center pb-5 bg-white rounded shadow">
                <div className="p-4 mb-4 d-flex justify-content-between">
                    <h5>Tampilan Form Order Katalog </h5>
                </div>
                <h4>Form penjualan belum aktif</h4>
                <p>Aktifkan sekarang dan permudah penjualan bisnis Anda!</p>
                <button
                    onClick={() => onSubmitCatalog()}
                    className="btn btn-primary col-3 mt-2">
                    Buat Form
                </button>
            </div>
        )
    }
    return (
        <div>
            <PaymentWarning user={user} type={"top"}/>
            <div className="bg-white rounded shadow">
                <div className="p-4 mb-4 d-flex justify-content-between">
                    <h5>Tampilan Form Order Katalog </h5>
                </div>
                <div className="row mr-0">
                    <div className="col-5 border-right address-window">
                        <h6 className="pl-4">Informasi Form</h6>

                        <div className="form-group pl-4 input-group-sm">
                            <label>Nama Brand </label>
                            <input
                                type="text"
                                onChange={handleCatalogChange('title')}
                                placeholder="Judul Katalog"
                                className="form-control"
                                value={catalog.title}
                            />
                        </div>
                        <div className="form-group pl-4 input-group-sm">
                            <label>Slogan Brand Anda </label>
                            <input
                                type="text"
                                onChange={handleCatalogChange('subtitle')}
                                placeholder="Sub Judul Katalog"
                                className="form-control"
                                value={catalog.subtitle}
                            />
                        </div>
                        <div className="form-group pl-4 input-group-sm">
                            <label>Deskripsi katalog Anda (Opsional) </label>
                            <textarea
                                type="text"
                                onChange={handleCatalogChange('description')}
                                placeholder="Deskripsi"
                                className="form-control"
                                value={catalog.description}
                            />
                        </div>
                        <hr/>
                        <h6 className="pl-4">Pilihan Kolom </h6>
                        <div className="form-group pl-4 pr-3 input-group-sm row">
                            <label className="col-sm-6 col-form-label">Isi Email</label>
                            <select
                                onChange={handleFieldChange('fieldEmail')}
                                className="custom-select form-control col-sm-6"
                                value={catalog.fieldEmail}
                            >
                                <option key={true} value={true}>Aktif</option>
                                <option key={false} value={false}>Non-Aktif</option>
                            </select>
                        </div>
                        <div className="form-group pl-4 pr-3 input-group-sm row">
                            <label className="col-sm-6 col-form-label">Isi Tambahan Harga</label>
                            <select
                                onChange={handleFieldChange('fieldAdditionalItem')}
                                className="custom-select form-control col-sm-6"
                                value={catalog.fieldAdditionalItem}
                            >
                                <option key={true} value={true}>Aktif</option>
                                <option key={false} value={false}>Non-Aktif</option>
                            </select>
                        </div>
                        {
                            catalog.fieldAdditionalItem ?
                                <div className=" pl-4 pr-3 input-group-sm form-row">
                                    <div className="form-group input-group-sm col-4">
                                        <input
                                            type="text"
                                            onChange={handleCatalogChange('additionalItemName')}
                                            placeholder="Nama Barang Tambahan"
                                            className="form-control"
                                            value={catalog.additionalItemName}
                                        />
                                    </div>
                                    <div className="form-group input-group-sm col-4">
                                        <input
                                            type="number"
                                            onChange={handleCatalogChange('additionalItemPrice')}
                                            placeholder="Harga"
                                            className="form-control"
                                            value={catalog.additionalItemPrice}
                                        />
                                    </div>
                                    <div className="form-group input-group-sm col-4">
                                        <select
                                            onChange={handleCatalogChange('additionalItemCourierBased')}
                                            className="custom-select form-control"
                                            value={catalog.additionalItemCourierBased}
                                        >
                                            <option key={'instant'} value={'instant'}>Instant</option>
                                            <option key={'non-instant'} value={'non-instant'}>non-Instant</option>
                                        </select>
                                    </div>
                                </div> : null
                        }
                        <hr/>
                        <h6 className="pl-4">Dekorasi </h6>
                        <div className="form-row pl-4">
                            <div className="form-group input-group-sm col-md-6">
                                <label>Font Judul</label>
                                <select
                                    onChange={handleStylingChange('titleFontFamily')}
                                    className="custom-select form-control"
                                >
                                    {
                                        fontFamily.map((i,idx) => (
                                            <option
                                                key={idx}
                                                value={i}
                                                className={`${idx === 0 ? "selected":""}`}
                                            >
                                                {i}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="form-group input-group-sm col-md-6">
                                <label>Font Subjudul</label>
                                <select
                                    onChange={handleStylingChange('subtitleFontFamily')}
                                    className="custom-select form-control"
                                >
                                    {
                                        fontFamily.map((i,idx) => (
                                            <option
                                                key={idx}
                                                value={i}
                                                className={`${idx === 0 ? "selected":""}`}
                                            >
                                                {i}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="form-group pl-4 input-group-sm ">
                            <label>Warna Background</label>
                            <input
                                type="text"
                                onClick={() => handleDisplayColor('backgroundColor')}
                                placeholder="Warna Background"
                                className="form-control"
                                value={catalog.style.backgroundColor}
                            />
                        </div>
                        <div className="form-row pl-4">
                            {
                                color.display ?
                                    <div style={{
                                        position: 'absolute',
                                        zIndex: '2',
                                    }}>
                                        <div
                                            style={{
                                                position: 'fixed',
                                                top: '0px',
                                                right: '0px',
                                                bottom: '0px',
                                                left: '0px',
                                            }}
                                            onClick={() => setColor({...color,display:false}) }/>
                                        <ChromePicker
                                            color={color.color}
                                            onChange={handleStylingChange(color.type)}
                                        />
                                    </div>
                                    :
                                    ''
                            }
                            <div className="form-group input-group-sm col-md-4">
                                <label>Warna Tombol</label>
                                <input
                                    type="text"
                                    onClick={() => handleDisplayColor('buttonColor')}
                                    placeholder="Warna Tombol"
                                    className="form-control"
                                    value={catalog.style.buttonColor}
                                />
                            </div>
                            <div className="form-group input-group-sm col-md-4">
                                <label>Garis Tombol</label>
                                <input
                                    type="text"
                                    onClick={() => handleDisplayColor('buttonBorderColor')}
                                    placeholder="Warna Tombol"
                                    className="form-control"
                                    value={catalog.style.buttonBorderColor}
                                />
                            </div>
                            <div className="form-group input-group-sm col-md-4">
                                <label>Font Tombol</label>
                                <input
                                    type="text"
                                    onClick={() => handleDisplayColor('buttonFontColor')}
                                    placeholder="Warna Tombol"
                                    className="form-control"
                                    value={catalog.style.buttonFontColor}
                                />
                            </div>
                        </div>
                        <label
                            style={{marginLeft:2}}
                            className="form-row pl-4 mb-0"
                        >
                            Gambar Form
                        </label>
                        <div
                            style={{fontSize:12, marginLeft:2}}
                            className="form-row pl-4 mb-2"
                        >
                            Ukuran gambar header 156 x 498 pixel
                        </div>
                        <div className="upload-receipt-wrapper pl-4 mb-4">
                            <Button
                                loading={loadingHeaderImage}
                                className="btn btn-outline-primary btn-block btn-sm">
                                {loadingHeaderImage? 'Sedang Upload Gambar' : 'Upload Gambar Untuk Header'}
                            </Button>
                            <input
                                type="file"
                                className="btn-secondary upload-receipt"
                                id="file-input-group"
                                accept="image/*"
                                onChange={e => onHeaderSelect( e, catalog.catalogId )}
                            />
                        </div>
                    </div>
                    <div className="col-7 px-0 pt-2 courier-window border-top border-bottom">
                        <div className="text-center mb-2">
                            <a href={catalog.link}>
                                Share Link Form Penjualan Anda: <b><u>{catalog.link}</u></b>
                            </a>
                        </div>
                        {/* form */}
                        <div
                            className="py-4 px-4"
                            style={{
                                backgroundColor: catalog.style.backgroundColor
                            }}>
                            <div
                                style={{width:528}}
                                className="container">
                                <div className="align-self-center">
                                    <div
                                        className="bg-lighter"
                                        style={{
                                            height:156,
                                            overflow: 'hidden',
                                            align: 'center'
                                        }}
                                    >
                                        <img
                                            className="image-header-form"
                                            src={catalog.style.headerImage}
                                        />
                                    </div>
                                </div>
                                <div className={`text-center bg-white py-4 border`}>
                                    <h2 style={{
                                        fontFamily: catalog.style.titleFontFamily
                                    }}>
                                        {catalog.title}
                                    </h2>
                                    <h5 style={{
                                        fontFamily: catalog.style.subtitleFontFamily
                                    }}>
                                        {catalog.subtitle}
                                    </h5>
                                    <p>{catalog.description}</p>
                                    { productView() }
                                    <div className="col-12 mt-4">
                                        <button
                                            className="btn btn-primary btn-block"
                                            style={{
                                                backgroundColor:catalog.style.buttonColor,
                                                borderColor:catalog.style.buttonBorderColor,
                                                color:catalog.style.buttonFontColor
                                            }}
                                        >
                                            Simpan
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-4 mb-4 text-right">
                    <div>
                        <a href={`/catalog`}>
                            <button
                                className="btn btn-outline-primary"
                            >
                                Kembali
                            </button>
                        </a>

                        <Button
                            className="btn btn-primary ml-2"
                            loading={loadingCatalog}
                            onClick={() => onUpdateCatalog()}
                        >
                            {loadingCatalog? 'Menyimpan' : 'Simpan'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>

    )
};


const fontFamily = [
    'Arial',
    'Andale Mono',
    'Brushstroke',
    'Coronetscript',
    'Courier',
    'Fixed',
    'Florence',
    'Gill Sans',
    'Helvetica',
    'Lato',
    'Palatino',
    'Times',
    'Times New Roman'
];


export default Form;
